// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
// Firebase servislerini import ediyoruz:
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage"; // Storage için

// Firebase Console'dan kopyaladığınız KENDİ firebaseConfig nesneniz:
// Firebase Console'dan kopyaladığınız KENDİ firebaseConfig nesneniz:
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Firebase App Check (reCAPTCHA Enterprise)
if (process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(
        process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY
      ),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("App Check init warning:", e);
  }
} else {
  console.error("❌ REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY is not set!");
}

// Firebase servislerini başlatıp export ediyoruz:
export const auth = getAuth(app);

// Auth persistence fallback (Safari/Private/Incognito compatibility)
(async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
  } catch (localError) {
    console.warn('Local persistence failed, falling back to session:', localError.code);
    try {
      await setPersistence(auth, browserSessionPersistence);
    } catch (sessionError) {
      console.warn('Session persistence failed, falling back to in-memory:', sessionError.code);
      await setPersistence(auth, inMemoryPersistence);
    }
  }
})();
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Development ortamında emulator kullan
if (process.env.NODE_ENV === "development") {
  // Functions emulator'a bağlan
  const { connectFunctionsEmulator } = require("firebase/functions");
  connectFunctionsEmulator(functions, "localhost", 5001);
}
// Storage export'u yukarıda aktif

export default app; // Firebase app instance'ını da export edebiliriz (opsiyonel)
